"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _ChannelInfo = _interopRequireDefault(require("./ChannelInfo"));
var _ChannelBanlist = _interopRequireDefault(require("./ChannelBanlist"));
var _ChannelInvitelist = _interopRequireDefault(require("./ChannelInvitelist"));
var _BufferSettings = _interopRequireDefault(require("./BufferSettings"));
// Helper to generate Vue's computed methods for getting/setting settings.
function generateComputedSetting(setting) {
  return {
    get() {
      return this.buffer.setting(setting);
    },
    set(newVal) {
      return this.buffer.setting(setting, newVal);
    }
  };
}
var _default = exports.default = {
  components: {
    ChannelInfo: _ChannelInfo.default,
    ChannelBanlist: _ChannelBanlist.default,
    ChannelInvitelist: _ChannelInvitelist.default,
    BufferSettings: _BufferSettings.default
  },
  props: ['network', 'buffer', 'sidebarState'],
  data() {
    return {
      pluginUiElements: _GlobalApi.default.singleton().sideBarPlugins,
      accessTab: 'banlist'
    };
  },
  computed: {
    messageFontSize: {
      get() {
        // Défaut 100 (= "Moyenne"). On aligne les anciennes valeurs (ex. 90)
        // sur l'option la plus proche pour que le select affiche un choix.
        let val = parseInt(this.$state.setting('messageFontSize'), 10) || 100;
        const options = [80, 100, 120, 140];
        return options.reduce((a, b) => Math.abs(b - val) < Math.abs(a - val) ? b : a);
      },
      set(val) {
        this.$state.setting('messageFontSize', parseInt(val, 10) || 100);
      }
    },
    settingShowTopicBar: {
      // Global : s'applique à TOUS les salons (pas par-salon).
      get() {
        return this.$state.setting('show_topic_bar');
      },
      set(newVal) {
        this.$state.setting('show_topic_bar', newVal);
      }
    },
    settingShowMessageColors: {
      // Couleurs mIRC des messages. Global (lu par renderers/Html.js via
      // state.setting('buffers.show_message_colors')). Désactivé par défaut.
      get() {
        return this.$state.setting('buffers.show_message_colors');
      },
      set(newVal) {
        this.$state.setting('buffers.show_message_colors', newVal);
      }
    },
    settingShowJoinParts: generateComputedSetting('show_joinparts'),
    settingShowKicks: generateComputedSetting('show_kicks'),
    settingShowTopics: generateComputedSetting('show_topics'),
    settingShowNickChanges: generateComputedSetting('show_nick_changes'),
    settingShowModeChanges: generateComputedSetting('show_mode_changes'),
    settingColouredNicklist: generateComputedSetting('coloured_nicklist'),
    settingExtraFormatting: generateComputedSetting('extra_formatting'),
    settingShareTyping: generateComputedSetting('share_typing'),
    areWeAnOp() {
      return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["SidebarSectionSettings"]
window._app_exports.components.SidebarSectionSettings = exports.default ? exports.default : exports;
